import React from "react";
import ModalFormChofer from "./ModalFormChofer";

const ModalChofer = ({ show, handleClose, chofer }) => {
  return (
    <ModalFormChofer show={show} handleClose={handleClose} chofer={chofer} />
  );
};

export default ModalChofer;
